/**
 * Takip XML'indeki <evrak evrakTuru="..."> niteliginin degerleri.
 *
 * UYAP takip acilisinda evrak yalnizca uc kategoriyle gonderilebiliyor:
 * Takip Talebi, Vekaletname ve Takibin Dayanagi. Takip Talebi XML'de tasinmadigi
 * icin bu nitelik yalnizca asagidaki iki degeri alir; turu cozulemeyen evrak
 * Takibin Dayanagi sayilir (DEV-2762).
 */
export enum UyapXmlEvrakTuru {
    VEKALETNAME = "1",
    TAKIBIN_DAYANAGI = "2",
}
